import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import Image from "./image";

class GenericPageTemplate extends React.Component {
  constructor(props) {
    super(props);
  }

  renderContent() {
    return {
      __html: this.props.data.datoCmsGenericPage.content
    };
  }

  render() {
    let data = this.props.data.datoCmsGenericPage;

    return (
      <div className="GenericPage">
        <div className="content">
          <h1 className="size--l">{data.title}</h1>
          <div dangerouslySetInnerHTML={this.renderContent()} />
        </div>
        <div
          className="image"
          style={{ backgroundImage: `url(${data.image.fluid.src})` }}
        >
          <img src={data.image.fluid.src} />
        </div>
      </div>
    );
  }
}

export default GenericPageTemplate;

GenericPageTemplate.propTypes = {
  data: PropTypes.shape({
    datoCmsGenericPage: PropTypes.object.isRequired
  }).isRequired
};

/* eslint no-undef: "off" */
export const query = graphql`
  query GenericPageQuery($id: String!) {
    datoCmsGenericPage(id: { eq: $id }) {
      id
      url
      title
      content
      image {
        id
        fluid(maxWidth: 1500, imgixParams: { fm: "jpg", auto: "compress" }) {
          sizes
          src
          srcSet
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/generic-page.js